import { Component } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
import { BasePage2 } from 'src/app/tools/abstract-classes/base-page2';
import { BaseService } from 'src/app/assabil-kernel/services/base-service';
import { LeanUtilsService } from 'src/app/tools/services/lean-utils-service';
import { LoyaltyProgramRelease } from 'src/app/assabil-sales/models/entities/loyalty-program-release';
import { LoyaltyService } from 'src/app/assabil-sales/services/sales-loyalty-service';
import { MatDialog } from '@angular/material/dialog';
import { LoyaltyProgramLov } from '../loyalty-program-lov/loyalty-program-lov.component';
import { PartnerLovComponent } from 'src/app/assabil-admin/components/master-data/partner/partner-lov/partner-lov.component';
import { LoyaltyProgramReleaseThresholdPipe } from 'src/app/assabil-sales/pipes/loyalty-program-release-threshold-pipe';
import { Kpi } from 'src/app/assabil-kernel/models/entities/control-tables/kpi-entity';


@Component({
  selector: 'loyalty-program-release-list',
  templateUrl: './loyalty-program-release-list.component.html',
  styleUrls: ['./loyalty-program-release-list.component.scss']
})

export class LoyaltyProgramReleaseListComponent extends BasePage2<LoyaltyProgramRelease> {

  loyaltyProgramReleases     : LoyaltyProgramRelease[] = [];
  loyaltyProgramCode         : string;
  loyaltyProgramReleaseCode  : string;
  startDate                  : Date;
  endDate                    : Date;
  active                     : boolean = true;
  inactive                   : boolean = true;
  kpis                       : Kpi[];

  constructor(   
    protected toastr                : ToastrService,
    protected router                : Router,
    protected loyaltyService        : LoyaltyService,
    protected baseService           : BaseService,
    protected leanUtilsService      : LeanUtilsService,
    protected dialog                : MatDialog,
    protected location              : Location) {
      super(toastr, router, baseService, leanUtilsService, location);

      this.entityName = "loyaltyProgramRelease";
  }


//--------------------------------------------------------------------------------------------------------------------
ngAfterViewInit(): void {
  super.ngAfterViewInit();
    this.loadKpis();
}
//--------------------------------------------------------------------------------------------------------------------

//--------------------------------------------------------------------------------------------------------------------
loadKpis() {
  this.loyaltyService.kpisGet(null, null).then(result => {
    this.kpis = result;
    this.setChildFields();
})
}
//--------------------------------------------------------------------------------------------------------------------

//--------------------------------------------------------------------------------------------------------------------
loyaltyProgramReleaseThresholdPipe : LoyaltyProgramReleaseThresholdPipe =new LoyaltyProgramReleaseThresholdPipe();
setChildFields(){
      this.baseService.fieldsGet('loyaltyProgramReleaseThreshold').then(result => {
            this.childFields = result.listFields;
            this.readOnly    = result.readOnly;

            this.childFields.forEach(field => {
                if (field.prop == 'partner') {
                 field.modal = PartnerLovComponent;
                 // field.subProp = 'designation'; not needed because Pipe will process the display
                 field.pipe  = this.loyaltyProgramReleaseThresholdPipe;
                }
                if (field.prop == 'kpi') {
                 field.lov  =   {key : "kpiCode",  value : "name",  data : this.kpis } ;
                 field.key  = 'kpiCode';
                 field.pipe = this.loyaltyProgramReleaseThresholdPipe;
                }
            })

      }) 
  }
//--------------------------------------------------------------------------------------------------------------------


//--------------------------------------------------------------------------------------------------------------------
getRows(): LoyaltyProgramRelease[] {
      return this.loyaltyProgramReleases;
  }
//--------------------------------------------------------------------------------------------------------------------



//--------------------------------------------------------------------------------------------------------------------
new(){
  let dialogRef = this.dialog.open(LoyaltyProgramLov);
  dialogRef.afterClosed().subscribe(result => {
    if(result){
      let loyaltyProgramRelease       : LoyaltyProgramRelease = new LoyaltyProgramRelease();
      loyaltyProgramRelease.inserted        = true;
      loyaltyProgramRelease.edit            = true;
      loyaltyProgramRelease.loyaltyProgram  = result;
      this.selectedRow                      = loyaltyProgramRelease;
    }
  });

}
//--------------------------------------------------------------------------------------------------------------------


//--------------------------------------------------------------------------------------------------------------------
loadData() {    
    this.loyaltyService.loyaltyProgramReleasesGet(this.loyaltyProgramCode, this.loyaltyProgramReleaseCode, this.startDate, this.endDate, this.active, this.inactive).then(result => {
        this.loyaltyProgramReleases = result;
  })
}
//--------------------------------------------------------------------------------------------------------------------
  
//--------------------------------------------------------------------------------------------------------------------
selectRow(loyaltyProgramRelease : LoyaltyProgramRelease){
    this.loyaltyService.loyaltyProgramReleaseGet(loyaltyProgramRelease.loyaltyProgramReleaseCode).then(result => {
      this.selectedRow = result;
  })
}
//--------------------------------------------------------------------------------------------------------------------

}
